<template>
    <Modal :value="showModal"
           title="Server Log info"
           width="800"
           :closable="false"
           :mask-closable="false"
           @on-visible-change="onVisibleChange">
        <div>
            <Row :gutter="32">
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Timestamp:</label>
                        <span>{{logData.timestamp}}</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Level:</label>
                        <span>{{logData.level}}</span>
                    </div>
                </i-col>
                <i-col :xs="24">
                    <div class="info-box">
                        <label>Message:</label>
                        <span>{{logData.message}}</span>
                    </div>
                </i-col>
                <Divider orientation="left" style="margin-top: 32px">Meta</Divider>
                <i-col :xs="12" v-if="logData.meta.Account">
                    <div class="info-box">
                        <label>Account:</label>
                        <span v-if="logData.meta.Account.MailAddress">{{logData.meta.Account.MailAddress}}</span>
                        <span v-else>{{logData.meta.Ip}}</span>
                    </div>
                </i-col>
                <i-col :xs="12" v-if="logData.meta.Account">
                    <div class="info-box">
                        <label>Role:</label>
                        <span>{{logData.meta.Account.role}}</span>
                    </div>
                </i-col>
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Request:</label>
                        <span>{{logData.meta.Request}}</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Method:</label>
                        <span>{{logData.meta.Method}}</span>
                    </div>
                </i-col>
                <i-col :xs="6">
                    <div class="info-box">
                        <label>Status:</label>
                        <span>{{logData.meta.Status}}</span>
                    </div>
                </i-col>
                <i-col :xs="24">
                    <div class="info-box">
                        <label>Url:</label>
                        <span>{{logData.meta.Url}}</span>
                    </div>
                </i-col>
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Params:</label>
                        <span>{{logData.meta.Params}}</span>
                    </div>
                </i-col>
                <i-col :xs="12">
                    <div class="info-box">
                        <label>Query:</label>
                        <span>{{logData.meta.Query}}</span>
                    </div>
                </i-col>
                <i-col :xs="24">
                    <div class="info-box">
                        <label>Body:</label>
                        <span>{{logData.meta.Body}}</span>
                    </div>
                </i-col>
            </Row>
        </div>
        <div slot="footer">
            <Button @click="showModal=false">Close</Button>
        </div>
    </Modal>
</template>

<script>
    export default {
        data() {
            return {
                showModal: false,
                logData:{
                    timestamp: "",
                    level: "",
                    message: "",
                    meta: {
                        Request: false,
                        Method: "",
                        Url: "",
                        Params: {},
                        Query: {
                            Offset: "",
                            MaxResults: ""
                        },
                        Body: {},
                        Status: null
                    }
                }
            };
        },
        methods: {
            triggerModal(log) {
                this.showModal = true;
                this.logData=log
            },
            onVisibleChange(val){
                if(!val) {
                    this.logData = {
                        timestamp: "",
                        level: "",
                        message: "",
                        meta: {
                            Request: false,
                            Method: "",
                            Url: "",
                            Params: {},
                            Query: {
                                Offset: "",
                                MaxResults: ""
                            },
                            Body: {},
                            Status: null
                        }
                    }
                }
            }
        }
    };
</script>
<style scoped>
    .info-box{
        margin-top: 16px;
    }
    .info-box>*{
        display: inline-block;
        vertical-align: middle;
    }
    .info-box label{
        font-weight: 600;
        margin-right: 8px;
    }
</style>
